import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import useToggle from '../../../../hooks/useToggle';
import { HealthScoreExplain } from '../../../HealthScore';
import DashboardCards from '../../../../components/DashboardCard/DashboardCards';
import { getAccountHealthScore } from '../../../../features/AccountHealthScore/accountHealthScoreAction';
import useAccountHealthScore from './useAccountHealthScore';
import AccountHealthScoreTable from './AccountHealthScoreTable';

export default function AccountHealthScore(props) {
  const {
    isShare, permissions, tenantId, accountOrgId, accountId,
  } = props;
  const dispatch = useDispatch();
  const [refreshHealthScore, setRefreshHealthScore] = useToggle();

  useEffect(() => {
    if (accountId) {
      dispatch(getAccountHealthScore({
        accountId, isShare, tenantId, accountOrgId,
      }));
    }
  }, [accountId, refreshHealthScore, isShare, tenantId, accountOrgId]);

  const {
    open, setOpen, selectedHealthScore, accountHealthScore, columns, handleClickSettings, error, loading,
  } = useAccountHealthScore({
    accountId, isShare, tenantId, accountOrgId,
  });
  return (
    <>
      <DashboardCards
        title="KPI Scores"
        showButton={(permissions.write && !isShare)}
        buttonText="Settings"
        onClick={handleClickSettings}
      >
        <AccountHealthScoreTable
          data={accountHealthScore?.accountsLicense}
          columns={columns}
          error={error}
          loading={loading}
          refresh={setRefreshHealthScore}
          message="No Rows"
        />
      </DashboardCards>
      <HealthScoreExplain open={open} setOpen={setOpen} isShare={isShare} permissions={permissions} healthScore={selectedHealthScore} />
    </>
  );
}
